import { Injectable } from '@angular/core';
import { IsfModel } from '@data-layer/models/isf';
import { ESTIMATED_VALUE_TOO_LARGE, QUANTITY_MISSING, QUANTITY_UNIT_MISSING, WEIGHT_MISSING } from '../const';
import { ManagementIsfModel } from '@data-layer/models/management';

@Injectable({ providedIn: 'root' })
export class IsfDetailsValidationService {
  constructor() {}

  public hasInformalEstimationValueInvalid(isf: IsfModel | ManagementIsfModel): boolean {
    return this.hasInformalInvalidField(isf, ESTIMATED_VALUE_TOO_LARGE);
  }

  public hasInformalQuantityInvalid(isf: IsfModel | ManagementIsfModel): boolean {
    return this.hasInformalInvalidField(isf, QUANTITY_MISSING) || this.hasInformalInvalidField(isf, QUANTITY_UNIT_MISSING);
  }

  public hasInformalWeightInvalid(isf: IsfModel | ManagementIsfModel): boolean {
    return this.hasInformalInvalidField(isf, WEIGHT_MISSING);
  }

  public hasInformalEstimationError(isf: IsfModel | ManagementIsfModel): boolean {
    return this.hasInformalEstimationValueInvalid(isf) || this.hasInformalQuantityInvalid(isf) || this.hasInformalWeightInvalid(isf);
  }

  private hasInformalInvalidField(isf: IsfModel | ManagementIsfModel, field: string): boolean {
    const errors = (isf?.estimatedInformation?.validationMessages || []).map((item) => item.text);
    if (errors.includes(field)) {
      return true;
    }
    return false;
  }
}
